import $api from "@/frontend/shared/api/axios";
import { TStagesResponse } from "../../const/const";

export async function deleteStage(stageId: number): Promise<TStagesResponse> {
  return $api.delete(`stages/${stageId}`).then((res) => {
    return res.data;
  });
}
